import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IHomeSupplier } from './home-supplier.model';
import { BaseService } from 'src/app/service/base.service';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class HomeSupplierService extends BaseService {

  constructor(public http: HttpClient) { super(http); }

  public getSupliers() {
    return this.http.get<IHomeSupplier>(environment.environmentEndpointUrl()+"api/Home/home-suppliers"
    ).toPromise();
  }
}
